'use strict'

const _ = require('lodash')

function runMultiple(callbacks) {
    return function () {
        // eslint-disable-next-line prefer-rest-params
        const args = arguments
        _.forEach(callbacks, callback => {
            callback.apply(this, args)
        })
    }
}

module.exports = {
    runMultiple
}
